import { Alert, Typography } from "antd";

const { Paragraph, Title } = Typography;

const DeadlinePassedMessage = () => {
  return (
    <div style={{ marginTop: 48, textAlign: "center" }}>
      <Alert
        message="Deadline Passed"
        description={
          <div>
            <Paragraph>
              The application deadline has passed. Profile creation is no longer
              available.
            </Paragraph>
            <Paragraph type="secondary">
              Please check back later for future opportunities.
            </Paragraph>
          </div>
        }
        type="warning"
        showIcon
        style={{ maxWidth: 600, margin: "0 auto" }}
      />
    </div>
  );
};

export default DeadlinePassedMessage;
